import { render, staticRenderFns } from "./TabSubscriptions.vue?vue&type=template&id=07fb733c&scoped=true&"
import script from "./TabSubscriptions.vue?vue&type=script&lang=js&"
export * from "./TabSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./TabSubscriptions.vue?vue&type=style&index=0&id=07fb733c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fb733c",
  null
  
)

export default component.exports